import { IGetFolhaPagamentoDetalheUseCase } from "../../../presentation/useCases/read/get_folha_pagamento_detalhe_use_case";
import { FolhaPagamentoDetalhe } from "../../models/folha_pagamento_detalhe";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetFolhaPagamentoDetalheUseCase
 */

export class GetFolhaPagamentoDetalheUseCase implements IGetFolhaPagamentoDetalheUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getFolhaPagamentoDetalhe(
    idItemFolhaPagamento: number,
  ): Promise<FolhaPagamentoDetalhe> {
    return await this.repository.getFolhaPagamentoDetalhe(
      idItemFolhaPagamento,
    );
  }
}
